import { CellContext } from '@tanstack/react-table';
import { Skeleton, tableHelpers } from '@round/creatorbase-ui';
import { useCreatorbaseCurrencies } from '@round/creatorbase-helpers/api-hooks';
import { asMoneyWithoutZeros } from 'helpers';
import {
    getMeta,
    NO_VALUE,
    OutreachResultRow,
} from 'Modules/Plans/OutreachRequests/OutreachRequestDetails/components/OutreachRequestResults/helpers';
import styles from './RateCell.module.css';

type Props = CellContext<tableHelpers.WithLoadingRow<OutreachResultRow>, unknown>;

/** The creator's upfront asking rate, shown as-is in their own currency — not a negotiated final rate. */
export const RateCell = ({ row: { original }, table }: Props) => {
    const { isLoading } = getMeta(table);
    const { getCurrencyById } = useCreatorbaseCurrencies();

    if (tableHelpers.isLoadingRow(original) || isLoading) {
        return <Skeleton className={styles.skeleton} />;
    }

    if (typeof original.cost !== 'number') {
        return NO_VALUE;
    }

    return <span>{asMoneyWithoutZeros(original.cost, getCurrencyById(original.currency_id))}</span>;
};
